import { Injectable, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SalesOrderLineFormGroup } from './sales-order-line-form-group.interface';

@Injectable()
export class SalesOrderLineFormModel {
  private readonly formBuilder = inject(FormBuilder);

  public readonly fieldNames = {
    inventoryItemId: 'inventoryItemId',
    description: 'description',
    description2: 'description2',
    quantity: 'quantity',
    unitOfMeasureId: 'unitOfMeasureId',
    unitPrice: 'unitPrice',
    taxPercent: 'taxPercent',
    currencyCode: 'currencyCode',
  } as const;

  public readonly form: FormGroup<SalesOrderLineFormGroup>;

  constructor() {
    const formBuilder = this.formBuilder;

    this.form = SalesOrderLineFormModel.buildFormGroup(formBuilder);
  }

  public buildFormGroup(): FormGroup<SalesOrderLineFormGroup> {
    return SalesOrderLineFormModel.buildFormGroup(this.formBuilder);
  }

  public static buildFormGroup(formBuilder: FormBuilder): FormGroup<SalesOrderLineFormGroup> {
    return formBuilder.group<SalesOrderLineFormGroup>({
      inventoryItemId: new FormControl<string | null>(null),
      description: new FormControl('', { nonNullable: true }),
      description2: new FormControl('', { nonNullable: true }),
      quantity: new FormControl(1, {
        nonNullable: true,
        validators: [Validators.required, Validators.min(0.0001)],
      }),
      unitOfMeasureId: new FormControl<number | null>(null, { validators: [Validators.required] }),
      unitPrice: new FormControl(0, {
        nonNullable: true,
        validators: [Validators.required, Validators.min(0)],
      }),
      taxPercent: new FormControl(0, {
        nonNullable: true,
        validators: [Validators.required, Validators.min(0)],
      }),
      // No Validators.required: the backend defaults from the linked inventory
      // item's base-UoM price when the field is null/empty. The picker pre-fills
      // the suggested value in the component only when the control is empty so
      // any user-set override survives subsequent item changes.
      currencyCode: new FormControl<string | null>(null),
    });
  }
}
